export default __webpack_public_path__ + "static/media/logo.32e65569.svg";